import axios from "axios";
import global from "./components/Global";

// Helper para sanitizar parámetros de URL
const encodeParam = (param) => encodeURIComponent(String(param || ""));

// Helper para manejar errores de axios de manera segura
const handleAxiosError = (error) => {
  if (error.response && error.response.data) {
    return error.response.data;
  }
  // Error de red o servidor no disponible
  return {
    status: "error",
    message: error.message || "Error de conexión con el servidor"
  };
};

export function getSucursales(latitude, longitude) { 
  var apiCall =
    global.apiRESTUrl + "/obtieneSucursales/" + latitude + "/" + longitude;  
  return (
    axios
      .get(apiCall)
      .then((response) => {
       
        return response.data;
      })     
      .catch((error) => {       
        return handleAxiosError(error);
      })
  );
}


export function getMarcas() {
  var apiCall = global.apiRESTUrl + "/obtieneMarcas";
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getVehiculos(idMarca) {
  const apiCall = global.apiRESTUrl + "/obtieneVehiculos/" + encodeParam(idMarca);
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getModelos(idTipoVehiculo) {
  const apiCall = global.apiRESTUrl + "/obtieneModelos/" + encodeParam(idTipoVehiculo);
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getFamilias(idTipoVehiculo, modelo) {
  var apiCall =
    global.apiRESTUrl + "/obtieneFamilias/" + idTipoVehiculo + "/" + modelo;
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getProductos(idTipoVehiculo, idFamilia, modelo) {
  var apiCall =
    global.apiRESTUrl +
    "/obtieneProductos/" +
    idTipoVehiculo +
    "/" +
    idFamilia +
    "/" +
    modelo; 
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function numberFormat(value) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal", //currency
    currency: "MXN",
    currencyDisplay: "symbol",
    minimumFractionDigits: 0,
  }).format(value);
}

export function getInventarioCEDIS(idAlmacen, codigo, idMarca) {
  var apiCall =
    global.apiRESTUrl +
    "/getInventarioCEDIS/" +
    idAlmacen +
    "/" +
    codigo.toUpperCase() +
    "/" +
    idMarca;
  return axios
    .get(apiCall ,{ timeout:5000 })
    .then((response) => {    
      return response;
    })
    .catch((error) => {      
      return error.response;
    });
}



export async function agregaComentarios(
  fuentep,codigop,fechap,comentariop
) {
  var apiCall = global.apiRESTUrl + "/agregaComentarioCodigo";
  const response = await axios
    .post(apiCall, {
     fuente:fuentep,
     codigo:codigop,
     fecha: fechap,
     comentario:comentariop
    })

    .catch((error) => {
      return error;
    });
  try {
    if (response.data.status === "success") {
      return response.data;
    } else return 0;
  } catch {
    return 0;
  }
}

export async function getInventarioCEDISAsync(idAlmacen, codigo, idMarca) {
  var apiCall =
    global.apiRESTUrl+
    "/getInventarioCEDIS/" +
    idAlmacen +
    "/" +
    codigo.toUpperCase() +
    "/" +
    idMarca;
  const response = await axios.get(apiCall, { timeout:5000 }).catch((error) => {    
    return error;
  });       
  try {   
    if (response.status === 200) 
    {     
      return response.data.result[0].inventario;
    }    
    else
    {
      return 0;
    }  
  } catch (error) {
    return 0;
  }  
}

export  function getInventarioNonAsync(idAlmacen, codigo, idMarca) {
  var apiCall =
    global.apiRESTUrl +
    "/getInventarioCEDIS/" +
    idAlmacen +
    "/" +
    codigo +
    "/" +
    idMarca;   
    return axios
    .get(apiCall)
    .then((response) => {         
      return response.data.result[0].inventario;
    })
    .catch((error) => {     
      return 99;
    });
}



export function getInventarioDetalladoCEDIS(codigo) {
  var apiCall =
    global.apiRESTUrl +
    "/obtieneInventarioDetalladoCEDIS/" + codigo.toUpperCase();      
  return axios
    .get(apiCall)
    .then((response) => {  
      return response;
    })
    .catch((error) => {     
      return error;
    });
}

export async function agregaDatosFacturacion(
  idClienteGovi,
  Nombre,
  Apellidos,
  Email,
  Empresa,
  RFC,
  Telefono,
  TelOficina,
  Calle,
  NumExterior,
  NumInterior,
  Colonia,
  Ciudad,
  CodigoPostal,
  Pais,
  Estado,
  TipoTarjeta,
  NombreTarjeta,
  NumeroTarjeta,
  MesTarjeta,
  AnioTarjeta
) {
  var apiCall = global.apiRESTUrl + "/agregaDatosFacturacion"; 
  const response = await axios
    .post(apiCall, {
      idClienteGovi: idClienteGovi,
      Nombre: Nombre,
      Apellidos: Apellidos,
      Email: Email,
      Empresa: Empresa,
      RFC: RFC,
      Telefono: Telefono,
      TelOficina: TelOficina,
      Calle: Calle,
      NumExterior: NumExterior,
      NumInterior: NumInterior,
      Colonia: Colonia,
      Ciudad: Ciudad,
      CodigoPostal: CodigoPostal,
      Pais: Pais,
      Estado: Estado,
      TipoTarjeta: TipoTarjeta,
      NombreTarjeta: NombreTarjeta,
      NumeroTarjeta: NumeroTarjeta,
      MesTarjeta: MesTarjeta,
      AnioTarjeta: AnioTarjeta
    })
    .catch((error) => {
      return error;
    });

  try {
    if (response.data.status === "success") {
      return response;
    } else return 0;
  } catch (error) {
    return 0;
  }
}

export async function agregaPedidos(
  idClienteGovi,
  idAlmacen,
  total,
  consignado,
  idClienteWeb
) {
  var apiCall = global.apiRESTUrl + "/agregaPedidos"; 
  const response = await axios
    .post(apiCall, {
      idClienteGovi: idClienteGovi,
      idAlmacen: idAlmacen,
      total: total,
      consignado: consignado,
      idClienteWeb: idClienteWeb,
    })
    .catch((error) => {    
      return error;
    });

  try {   
    if (response.data.status === "success") {     
      return response.data.result[0].idPedido;
    } else return 0;
  } catch (error) {
    return 0;
  }
}



export async function actualizaGuia(
  idPedidoP, estatusP, numeroGuiaP
) {
  var apiCall = global.apiRESTUrl + "/actualizaGuia"; 
  const response = await axios
    .post(apiCall, {
      idPedido: idPedidoP,
      estatus: estatusP,
      numeroGuia: numeroGuiaP,
    }).then((response) => 
    {
     
        return response;
        
    })
    .catch((error) => {   
      return error;
    });
    try {
        return response;
    } catch (error) 
    {
     return error;
    }
}

export async function agregaDetallePedidos(
  idPedido,
  producto,
  descripcion,
  cantidad,
  precio,
  idMarca,
  marca
) {
  var apiCall = global.apiRESTUrl + "/agregaDetallePedidos";

  const response = await axios
    .post(apiCall, {
      idPedido: idPedido,
      producto: producto,
      descripcion: descripcion,
      cantidad: cantidad,
      precio: precio,
      idMarca: idMarca,
      marca: marca,
    })
    .catch((error) => {
      return error;
    });
  try {
    if (response.data.status === "success") {   
      return response.data.result[0].Message;
    } else return 0;
  } catch (error) {
    return 0;
  }
}

export function getPedidos(idCliente, idAlmacen, top) {
  var apiCall = global.apiRESTUrl + "/obtienePedidos/" + idCliente +"/" +idAlmacen +  "/" + top;  
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getPedidosAdmon() {
  var apiCall = global.apiRESTUrl + "/obtienePedidosAdmon";  
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getNumPedidos(idCliente, idAlmacen) {
  var apiCall = global.apiRESTUrl + "/obtieneNumPedidos/" + idCliente+ "/" + idAlmacen;   
  //console.log(apiCall);
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getPedido(idPedido) {
  var apiCall = global.apiRESTUrl + "/obtienePedido/" + idPedido;
//  console.log(apiCall);
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {    
      return handleAxiosError(error);
    });
}

export function getAllVehiculos() {
  var apiCall = global.apiRESTUrl + "/obtieneTodosVehiculos";
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getProductosByCode(codigo, equivalencias) {
  var apiCall =
    global.apiRESTUrl +
    "/obtieneProductosByCode/" +
    codigo +
    "/" +
    equivalencias;
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}


export async function getProductosByCodePlantilla(codigo, equivalencias) {
  var apiCall =
    global.apiRESTUrl +
    "/obtieneProductosByCodePlantilla/" +
    codigo +
    "/" +
    equivalencias;    
  return await axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getProductosPlantilla() {
  const apiCall =
    global.apiRESTUrl +
    "/obtieneProductosPlantilla/"
    
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getProductosByCodeDetalle(codigo) {
  const apiCall =
    global.apiRESTUrl +
    "/obtieneProductosByCodeDetalle/" +
    codigo
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getProductosByDescripcion(desc) {
  const apiCall = global.apiRESTUrl + "/obtieneProductosByDescripcion/" + encodeParam(desc);
  return axios
    .get(apiCall)
    .then((response) => {   
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getMarcasProductosNuevos() {
  var apiCall = global.apiRESTUrl + "/obtieneMarcasProductosNuevos/";
  return axios
    .get(apiCall)
    .then((response) => {   
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}


export function getFamiliasProductosNuevos(fechaInicial, fechaFinal,idMarca) {
  var apiCall = global.apiRESTUrl + "/obtieneFamiliasProductosNuevos/" +fechaInicial +"/"+ fechaFinal+"/"+  idMarca; 
  return axios
    .get(apiCall)
    .then((response) => {   
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}


export function getDatosFacturacion(idClienteGOVI) {
  var apiCall = global.apiRESTUrl + "/obtieneDatosFacturacion/" +idClienteGOVI; 
  return axios
    .get(apiCall)
    .then((response) => {   
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getProductosNuevos(fechaInicial, fechaFinal,idMarca, idFamilia) {
  var apiCall = global.apiRESTUrl + "/obtieneProductosNuevos/" +fechaInicial +"/"+ fechaFinal+"/"+  idMarca+ "/"+ idFamilia; 
  return axios
    .get(apiCall)
    .then((response) => {   
      return response.data;
    })
    .catch((error) => {      
      return handleAxiosError(error);
    });
}

export function getProductosByDescCode(codigo) {
  const apiCall = global.apiRESTUrl + "/obtieneProductosByDescCode/" + encodeParam(codigo);
  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getRecomendados()
{
  var apiCall = global.apiRESTUrl + "/obtieneRecomendaciones/";
  return axios
    .get(apiCall)
    .then((response) => {
     // console.log(response);
      return response.data;
    })
    .catch((error) => {     
      return handleAxiosError(error);
    });
}

export function getPrivilegios() {
  var apiCall = global.apiRESTUrl + "/obtienePrivilegios"; 
  return axios
    .get(apiCall)
    .then((response) => {   
     //console.log(response.data.result);
     // sessionStorage.setItem("privilegios", response.data);
      return response.data;
    })
    .catch((error) => {      
      return error;
    });
}

export function getUbicacionesGrupoNOCEDIS() {
  const apiCall = global.apiRESTUrl + "/obtieneUbicacionesGrupoNOCEDIS";
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}


export function getUbicacionSucursales(ordenGrupo) {
  const apiCall = global.apiRESTUrl + "/obtieneUbicacionSucursales/" + ordenGrupo;
  
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}


export function getUbicacionesGrupo() {
  const apiCall = global.apiRESTUrl + "/obtieneUbicacionesGrupo";
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function obtieneFamiliaProductos(idFamilia) {
  const apiCall = global.apiRESTUrl + "/obtieneFamiliaProductos/" + idFamilia;
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
export function getFamiliasImg() {
  const apiCall = global.apiRESTUrl + "/obtieneFamiliasImg";
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function getConfig(config) {
  const apiCall = global.apiRESTUrl + "/obtieneConfiguraciones/" + config;
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export async function sendMail(
  pMailReceiver,
  pNombre,
  pEmail,
  pTelefono,
  pComentarios,
  pEstado,
  pCiudad,
  pDepartamento,
  pWebsite = "" // Honeypot field - should always be empty for real users
) {
  const apiCall = global.apiRESTUrl + "/enviarEMail";
  const response = await axios
    .post(apiCall, {
      to: pMailReceiver,
      subject: `Contacto GROB.MX - ${pDepartamento}`,
      nombre: pNombre,
      email: pEmail,
      telefono: pTelefono,
      comentarios: pComentarios,
      estado: pEstado,
      ciudad: pCiudad,
      departamento: pDepartamento,
      fax_number: pWebsite, // Honeypot
    })
    .catch((error) => {
      // Capturar el mensaje de error del backend (ej: rate limit)
      if (error.response && error.response.data) {
        return { success: false, message: error.response.data.message };
      }
      return { success: false, message: "Error de conexión con el servidor" };
    });
  try {
    if (response.data && response.data.status === "success") {
      return { success: true };
    } else if (response.success === false) {
      // Error ya procesado del catch
      return response;
    } else {
      return { success: false, message: response.data?.message || "Error al enviar el correo" };
    }
  } catch (error) {
    return { success: false, message: "Error al enviar el correo" };
  }
}

export function getDepartamentos() {
  const apiCall = global.apiRESTUrl + "/obtieneDepartamentos";
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}


export function getEstados() {
  const apiCall = global.apiRESTUrl + "/obtieneEstados";
  return axios
    .get(apiCall)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function getAllVehiculosServicioPesado() {
  const apiCall = global.apiRESTUrl + "/obtieneTodosVehiculosServicioPesado";

  return axios
    .get(apiCall)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return handleAxiosError(error);
    });
}

export async function comprobarCaptcha(captchA) {
  const apiCall = global.apiRESTUrl + "/compruebaCaptcha";

  return await axios.post(apiCall, { captcha: captchA }).catch((error) => {
    return error;
  });
}
